import { defineAsyncComponent } from 'vue';

export { default as AppHighlightedText } from './AppHighlightedText.vue';
export { default as AppScrollLoader } from './AppScrollLoader';
export { default as AppCompanyLogo } from './AppCompanyLogo';
export { default as AppQuickActions } from './AppQuickActions';
export { default as AppDropdown } from './AppDropdown';
export { default as AppFilterBar } from './AppFilterBar.vue';
export {
	default as AppConfirmationPopover,
	type AppConfirmationPopoverProps,
} from './AppConfirmationPopover.vue';
export { default as AppRequiredFieldWrapper } from './AppRequiredFieldWrapper.vue';
export { default as AppRequiredFieldMarker } from './AppRequiredFieldMarker.vue';
export { default as AppTranslatedTextWithHTML } from './AppTranslatedTextWithHTML.vue';
export { default as AppDatePicker } from './AppDatePicker';
export { default as AppDatePickerInline } from './AppDatePicker/AppDatePickerInline.vue';
export { default as AppVimeoModal } from './AppVimeoModal';
export * from './AppChart';
export * from './AppNav';
export { default as AppSlideTransition } from './AppSlideTransition.vue';
export { default as AppHTMLFromMonolith } from './AppHTMLFromMonolith';
export { default as AppFetchHTMLFromMonolith } from './AppFetchHTMLFromMonolith';
export { default as AppLazyLoaderComponentFromMonolith } from './AppLazyLoaderComponentFromMonolith.vue';
export {
	AppAutoSuggest,
	CurrencyAutoSuggest,
	AutoSuggestDefaultEmits,
} from './AppAutoSuggest';
export { default as AppActivityLog } from './AppActivityLog.vue';
export { default as AppMetricsList, useMetricsList } from './AppMetricsList';
export { default as AppHtml } from './AppHtml.vue';
export { default as AppReportEmptyState } from './AppReportEmptyState.vue';

export const appMicroFrontends = {
	AppHeader: defineAsyncComponent(() => import('./AppHeader')),
	AppRequiredFieldMarker: defineAsyncComponent(
		() => import('./AppRequiredFieldMarker.vue')
	),
	AppIframeModal: defineAsyncComponent(
		() => import('./AppIframeModal/AppIframeModal.vue')
	),
	AppTextEditorContainer: defineAsyncComponent(
		() => import('./AppTextEditor/AppTextEditorContainer.vue')
	),
	AppBanner: defineAsyncComponent(() => import('./AppBanner/AppBanner.vue')),
};
